import blobticService from '../../Commun/services/blobticService';
import {
  CrmLead, CrmContact, CrmOpportunity, CrmActivity, CrmDashboardStats,
  CrmOrganisation, CrmCdc, CrmVisit, CrmChantier, CrmReclamation
} from '../types/crm';

export const mapLead = (dto: any): CrmLead => ({
  id: dto.CLD_IDF,
  CLD_IDF: dto.CLD_IDF,
  CLD_UIDF: dto.CLD_UIDF,
  code: dto.CLD_CODE || '',
  CLD_CODE: dto.CLD_CODE || '',
  name: dto.CLD_NAME || '',
  CLD_NAME: dto.CLD_NAME || '',
  company: dto.CLD_COMPANY || '',
  CLD_COMPANY: dto.CLD_COMPANY || '',
  email: dto.CLD_EMAIL || '',
  CLD_EMAIL: dto.CLD_EMAIL || '',
  phone: dto.CLD_PHONE || '',
  CLD_PHONE: dto.CLD_PHONE || '',
  status: dto.CLD_STATUS || 'NEW',
  CLD_STATUS: dto.CLD_STATUS || 'NEW',
  source: dto.CLD_SOURCE || 'WEBSITE',
  CLD_SOURCE: dto.CLD_SOURCE || 'WEBSITE',
  value: Number(dto.CLD_VALUE || 0),
  CLD_VALUE: Number(dto.CLD_VALUE || 0),
  notes: dto.CLD_NOTES || '',
  CLD_NOTES: dto.CLD_NOTES || '',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapContact = (dto: any): CrmContact => ({
  id: dto.CCT_IDF,
  CCT_IDF: dto.CCT_IDF,
  CCT_UIDF: dto.CCT_UIDF,
  code: dto.CCT_CODE || '',
  CCT_CODE: dto.CCT_CODE || '',
  firstName: dto.CCT_FIRSTNAME || '',
  CCT_FIRSTNAME: dto.CCT_FIRSTNAME || '',
  lastName: dto.CCT_LASTNAME || '',
  CCT_LASTNAME: dto.CCT_LASTNAME || '',
  organisationId: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  COR_IDF: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  organisationName: dto.ORGANISATION_NAME || '',
  company: dto.CCT_COMPANY || '',
  CCT_COMPANY: dto.CCT_COMPANY || '',
  role: dto.CCT_ROLE || '',
  CCT_ROLE: dto.CCT_ROLE || '',
  email: dto.CCT_EMAIL || '',
  CCT_EMAIL: dto.CCT_EMAIL || '',
  phone: dto.CCT_PHONE || '',
  CCT_PHONE: dto.CCT_PHONE || '',
  mobile: dto.CCT_MOBILE || '',
  CCT_MOBILE: dto.CCT_MOBILE || '',
  address: dto.CCT_ADDRESS || '',
  CCT_ADDRESS: dto.CCT_ADDRESS || '',
  city: dto.CCT_CITY || '',
  CCT_CITY: dto.CCT_CITY || '',
  type: dto.CCT_TYPE || 'CLIENT',
  CCT_TYPE: dto.CCT_TYPE || 'CLIENT',
  influence: dto.CCT_INFLUENCE ? Number(dto.CCT_INFLUENCE) : 3,
  CCT_INFLUENCE: dto.CCT_INFLUENCE ? Number(dto.CCT_INFLUENCE) : 3,
  prefComm: dto.CCT_PREF_COMM || 'EMAIL',
  CCT_PREF_COMM: dto.CCT_PREF_COMM || 'EMAIL',
  prefHours: dto.CCT_PREF_HOURS || '',
  CCT_PREF_HOURS: dto.CCT_PREF_HOURS || '',
  prefLang: dto.CCT_PREF_LANG || 'FR',
  CCT_PREF_LANG: dto.CCT_PREF_LANG || 'FR',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapOpportunity = (dto: any): CrmOpportunity => ({
  id: dto.COP_IDF,
  COP_IDF: dto.COP_IDF,
  COP_UIDF: dto.COP_UIDF,
  code: dto.COP_CODE || '',
  COP_CODE: dto.COP_CODE || '',
  title: dto.COP_TITLE || '',
  COP_TITLE: dto.COP_TITLE || '',
  contactId: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  CCT_IDF: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  contactName: dto.CONTACT_NAME || '',
  contactCompany: dto.CONTACT_COMPANY || '',
  organisationId: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  COR_IDF: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  organisationName: dto.ORGANISATION_NAME || '',
  refInterne: dto.COP_REF_INTERNE || '',
  COP_REF_INTERNE: dto.COP_REF_INTERNE || '',
  typeProjet: dto.COP_TYPE_PROJET || 'PROMOTION',
  COP_TYPE_PROJET: dto.COP_TYPE_PROJET || 'PROMOTION',
  segment: dto.COP_SEGMENT || 'PRIVE',
  COP_SEGMENT: dto.COP_SEGMENT || 'PRIVE',
  chantierAddress: dto.COP_CHANTIER_ADDRESS || '',
  COP_CHANTIER_ADDRESS: dto.COP_CHANTIER_ADDRESS || '',
  wilaya: dto.COP_WILAYA || '',
  COP_WILAYA: dto.COP_WILAYA || '',
  gamme: dto.COP_GAMME || 'URBANIA',
  COP_GAMME: dto.COP_GAMME || 'URBANIA',
  units: Number(dto.COP_UNITS || 0),
  COP_UNITS: Number(dto.COP_UNITS || 0),
  unitPrice: Number(dto.COP_UNIT_PRICE || 0),
  COP_UNIT_PRICE: Number(dto.COP_UNIT_PRICE || 0),
  discount: Number(dto.COP_DISCOUNT || 0),
  COP_DISCOUNT: Number(dto.COP_DISCOUNT || 0),
  extraDiscount: Number(dto.COP_EXTRA_DISCOUNT || 0),
  COP_EXTRA_DISCOUNT: Number(dto.COP_EXTRA_DISCOUNT || 0),
  progress: Number(dto.COP_PROGRESS || 0),
  COP_PROGRESS: Number(dto.COP_PROGRESS || 0),
  priority: dto.COP_PRIORITY || 'MEDIUM',
  COP_PRIORITY: dto.COP_PRIORITY || 'MEDIUM',
  risk: dto.COP_RISK || 'LOW',
  COP_RISK: dto.COP_RISK || 'LOW',
  prescripteurId: dto.COP_PRESCRIPTEUR_IDF ? Number(dto.COP_PRESCRIPTEUR_IDF) : undefined,
  COP_PRESCRIPTEUR_IDF: dto.COP_PRESCRIPTEUR_IDF ? Number(dto.COP_PRESCRIPTEUR_IDF) : undefined,
  kamId: dto.COP_KAM_IDF ? Number(dto.COP_KAM_IDF) : undefined,
  COP_KAM_IDF: dto.COP_KAM_IDF ? Number(dto.COP_KAM_IDF) : undefined,
  transferStatus: dto.COP_TRANSFER_STATUS || 'NONE',
  COP_TRANSFER_STATUS: dto.COP_TRANSFER_STATUS || 'NONE',
  transferDate: dto.COP_TRANSFER_DATE ? new Date(dto.COP_TRANSFER_DATE).toISOString().split('T')[0] : '',
  COP_TRANSFER_DATE: dto.COP_TRANSFER_DATE,
  actionRequired: dto.COP_ACTION_REQUIRED || '',
  COP_ACTION_REQUIRED: dto.COP_ACTION_REQUIRED || '',
  stage: dto.COP_STAGE || 'PROSPECTING',
  COP_STAGE: dto.COP_STAGE || 'PROSPECTING',
  amount: Number(dto.COP_AMOUNT || 0),
  COP_AMOUNT: Number(dto.COP_AMOUNT || 0),
  probability: Number(dto.COP_PROBABILITY || 20),
  COP_PROBABILITY: Number(dto.COP_PROBABILITY || 20),
  closeDate: dto.COP_CLOSEDATE ? new Date(dto.COP_CLOSEDATE).toISOString().split('T')[0] : '',
  COP_CLOSEDATE: dto.COP_CLOSEDATE,
  notes: dto.COP_NOTES || '',
  COP_NOTES: dto.COP_NOTES || '',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapOrganisation = (dto: any): CrmOrganisation => ({
  id: dto.COR_IDF,
  COR_IDF: dto.COR_IDF,
  COR_UIDF: dto.COR_UIDF,
  code: dto.COR_CODE || '',
  COR_CODE: dto.COR_CODE || '',
  name: dto.COR_NAME || '',
  COR_NAME: dto.COR_NAME || '',
  type: dto.COR_TYPE || 'BET',
  COR_TYPE: dto.COR_TYPE || 'BET',
  specialty: dto.COR_SPECIALTY || 'RESIDENTIEL',
  COR_SPECIALTY: dto.COR_SPECIALTY || 'RESIDENTIEL',
  size: dto.COR_SIZE || 'MOYEN',
  COR_SIZE: dto.COR_SIZE || 'MOYEN',
  zoneGeo: dto.COR_ZONE_GEO || '',
  COR_ZONE_GEO: dto.COR_ZONE_GEO || '',
  address: dto.COR_ADDRESS || '',
  COR_ADDRESS: dto.COR_ADDRESS || '',
  phone: dto.COR_PHONE || '',
  COR_PHONE: dto.COR_PHONE || '',
  email: dto.COR_EMAIL || '',
  COR_EMAIL: dto.COR_EMAIL || '',
  website: dto.COR_WEBSITE || '',
  COR_WEBSITE: dto.COR_WEBSITE || '',
  history: dto.COR_HISTORY || '',
  COR_HISTORY: dto.COR_HISTORY || '',
  contactsCount: Number(dto.CONTACTS_COUNT || 0),
  projectsCount: Number(dto.PROJECTS_COUNT || 0),
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapCdc = (dto: any): CrmCdc => ({
  id: dto.CDC_IDF,
  CDC_IDF: dto.CDC_IDF,
  CDC_UIDF: dto.CDC_UIDF,
  code: dto.CDC_CODE || '',
  CDC_CODE: dto.CDC_CODE || '',
  title: dto.CDC_TITLE || '',
  CDC_TITLE: dto.CDC_TITLE || '',
  projectId: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  COP_IDF: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  projectTitle: dto.PROJECT_TITLE || '',
  organisationId: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  COR_IDF: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  organisationName: dto.ORGANISATION_NAME || '',
  contactId: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  CCT_IDF: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  contactName: dto.CONTACT_NAME || '',
  dateCreation: dto.CDC_DATE_CREATION ? new Date(dto.CDC_DATE_CREATION).toISOString().split('T')[0] : '',
  CDC_DATE_CREATION: dto.CDC_DATE_CREATION,
  dateSignature: dto.CDC_DATE_SIGNATURE ? new Date(dto.CDC_DATE_SIGNATURE).toISOString().split('T')[0] : '',
  CDC_DATE_SIGNATURE: dto.CDC_DATE_SIGNATURE,
  status: dto.CDC_STATUS || 'DRAFT',
  CDC_STATUS: dto.CDC_STATUS || 'DRAFT',
  gamme: dto.CDC_GAMME || 'URBANIA',
  CDC_GAMME: dto.CDC_GAMME || 'URBANIA',
  unitsCount: Number(dto.CDC_UNITS_COUNT || 0),
  CDC_UNITS_COUNT: Number(dto.CDC_UNITS_COUNT || 0),
  estimatedBudget: Number(dto.CDC_ESTIMATED_BUDGET || 0),
  CDC_ESTIMATED_BUDGET: Number(dto.CDC_ESTIMATED_BUDGET || 0),
  technicalConstraints: dto.CDC_TECHNICAL_CONSTRAINTS || '',
  CDC_TECHNICAL_CONSTRAINTS: dto.CDC_TECHNICAL_CONSTRAINTS || '',
  docPath: dto.CDC_DOC_PATH || '',
  CDC_DOC_PATH: dto.CDC_DOC_PATH || '',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapVisit = (dto: any): CrmVisit => ({
  id: dto.CVS_IDF,
  CVS_IDF: dto.CVS_IDF,
  CVS_UIDF: dto.CVS_UIDF,
  code: dto.CVS_CODE || '',
  CVS_CODE: dto.CVS_CODE || '',
  role: dto.CVS_ROLE || 'PRESCRIPTEUR',
  CVS_ROLE: dto.CVS_ROLE || 'PRESCRIPTEUR',
  type: dto.CVS_TYPE || 'PROSPECTION',
  CVS_TYPE: dto.CVS_TYPE || 'PROSPECTION',
  organisationId: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  COR_IDF: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  organisationName: dto.ORGANISATION_NAME || '',
  contactId: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  CCT_IDF: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  contactName: dto.CONTACT_NAME || '',
  projectId: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  COP_IDF: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  projectTitle: dto.PROJECT_TITLE || '',
  scheduledDateTime: dto.CVS_SCHEDULED_DATETIME ? new Date(dto.CVS_SCHEDULED_DATETIME).toISOString().substring(0, 16) : '',
  CVS_SCHEDULED_DATETIME: dto.CVS_SCHEDULED_DATETIME,
  objective: dto.CVS_OBJECTIVE || '',
  CVS_OBJECTIVE: dto.CVS_OBJECTIVE || '',
  checklist: dto.CVS_CHECKLIST || '',
  CVS_CHECKLIST: dto.CVS_CHECKLIST || '',
  status: dto.CVS_STATUS || 'PLANNED',
  CVS_STATUS: dto.CVS_STATUS || 'PLANNED',
  checkinTime: dto.CVS_CHECKIN_TIME ? new Date(dto.CVS_CHECKIN_TIME).toISOString().substring(0, 16) : '',
  CVS_CHECKIN_TIME: dto.CVS_CHECKIN_TIME,
  checkinLat: dto.CVS_CHECKIN_LAT ? Number(dto.CVS_CHECKIN_LAT) : undefined,
  CVS_CHECKIN_LAT: dto.CVS_CHECKIN_LAT ? Number(dto.CVS_CHECKIN_LAT) : undefined,
  checkinLon: dto.CVS_CHECKIN_LON ? Number(dto.CVS_CHECKIN_LON) : undefined,
  CVS_CHECKIN_LON: dto.CVS_CHECKIN_LON ? Number(dto.CVS_CHECKIN_LON) : undefined,
  checkoutTime: dto.CVS_CHECKOUT_TIME ? new Date(dto.CVS_CHECKOUT_TIME).toISOString().substring(0, 16) : '',
  CVS_CHECKOUT_TIME: dto.CVS_CHECKOUT_TIME,
  durationMinutes: Number(dto.CVS_DURATION_MINUTES || 0),
  CVS_DURATION_MINUTES: Number(dto.CVS_DURATION_MINUTES || 0),
  personsMet: dto.CVS_PERSONS_MET || '',
  CVS_PERSONS_MET: dto.CVS_PERSONS_MET || '',
  topics: dto.CVS_TOPICS || '',
  CVS_TOPICS: dto.CVS_TOPICS || '',
  commitments: dto.CVS_COMMITMENTS || '',
  CVS_COMMITMENTS: dto.CVS_COMMITMENTS || '',
  nextSteps: dto.CVS_NEXT_STEPS || '',
  CVS_NEXT_STEPS: dto.CVS_NEXT_STEPS || '',
  evaluationScore: Number(dto.CVS_EVALUATION_SCORE || 8),
  CVS_EVALUATION_SCORE: Number(dto.CVS_EVALUATION_SCORE || 8),
  report: dto.CVS_REPORT || '',
  CVS_REPORT: dto.CVS_REPORT || '',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapChantier = (dto: any): CrmChantier => ({
  id: dto.CCH_IDF,
  CCH_IDF: dto.CCH_IDF,
  CCH_UIDF: dto.CCH_UIDF,
  code: dto.CCH_CODE || '',
  CCH_CODE: dto.CCH_CODE || '',
  title: dto.CCH_TITLE || '',
  CCH_TITLE: dto.CCH_TITLE || '',
  projectId: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  COP_IDF: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  projectTitle: dto.PROJECT_TITLE || '',
  organisationId: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  COR_IDF: dto.COR_IDF ? Number(dto.COR_IDF) : undefined,
  organisationName: dto.ORGANISATION_NAME || '',
  contactId: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  CCT_IDF: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  contactName: dto.CONTACT_NAME || '',
  clientName: dto.CCH_CLIENT_NAME || '',
  CCH_CLIENT_NAME: dto.CCH_CLIENT_NAME || '',
  address: dto.CCH_ADDRESS || '',
  CCH_ADDRESS: dto.CCH_ADDRESS || '',
  wilaya: dto.CCH_WILAYA || '',
  CCH_WILAYA: dto.CCH_WILAYA || '',
  status: dto.CCH_STATUS || 'DEMARRAGE',
  CCH_STATUS: dto.CCH_STATUS || 'DEMARRAGE',
  startDate: dto.CCH_START_DATE ? new Date(dto.CCH_START_DATE).toISOString().split('T')[0] : '',
  CCH_START_DATE: dto.CCH_START_DATE,
  estimatedEndDate: dto.CCH_ESTIMATED_END_DATE ? new Date(dto.CCH_ESTIMATED_END_DATE).toISOString().split('T')[0] : '',
  CCH_ESTIMATED_END_DATE: dto.CCH_ESTIMATED_END_DATE,
  actualEndDate: dto.CCH_ACTUAL_END_DATE ? new Date(dto.CCH_ACTUAL_END_DATE).toISOString().split('T')[0] : '',
  CCH_ACTUAL_END_DATE: dto.CCH_ACTUAL_END_DATE,
  progress: Number(dto.CCH_PROGRESS || 0),
  CCH_PROGRESS: Number(dto.CCH_PROGRESS || 0),
  kamName: dto.CCH_KAM_NAME || '',
  CCH_KAM_NAME: dto.CCH_KAM_NAME || '',
  ordersCount: Number(dto.CCH_ORDERS_COUNT || 0),
  CCH_ORDERS_COUNT: Number(dto.CCH_ORDERS_COUNT || 0),
  ordersPending: Number(dto.CCH_ORDERS_PENDING || 0),
  CCH_ORDERS_PENDING: Number(dto.CCH_ORDERS_PENDING || 0),
  ordersLate: Number(dto.CCH_ORDERS_LATE || 0),
  CCH_ORDERS_LATE: Number(dto.CCH_ORDERS_LATE || 0),
  deliveryStatus: dto.CCH_DELIVERY_STATUS || 'ON_SCHEDULE',
  CCH_DELIVERY_STATUS: dto.CCH_DELIVERY_STATUS || 'ON_SCHEDULE',
  totalCa: Number(dto.CCH_TOTAL_CA || 0),
  CCH_TOTAL_CA: Number(dto.CCH_TOTAL_CA || 0),
  marginPct: Number(dto.CCH_MARGIN_PCT || 0),
  CCH_MARGIN_PCT: Number(dto.CCH_MARGIN_PCT || 0),
  collectedPct: Number(dto.CCH_COLLECTED_PCT || 0),
  CCH_COLLECTED_PCT: Number(dto.CCH_COLLECTED_PCT || 0),
  satisfactionScore: Number(dto.CCH_SATISFACTION_SCORE || 85),
  CCH_SATISFACTION_SCORE: Number(dto.CCH_SATISFACTION_SCORE || 85),
  reclamationsCount: Number(dto.RECLAMATIONS_COUNT || 0),
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapReclamation = (dto: any): CrmReclamation => ({
  id: dto.CRC_IDF,
  CRC_IDF: dto.CRC_IDF,
  CRC_UIDF: dto.CRC_UIDF,
  code: dto.CRC_CODE || '',
  CRC_CODE: dto.CRC_CODE || '',
  chantierId: dto.CCH_IDF ? Number(dto.CCH_IDF) : undefined,
  CCH_IDF: dto.CCH_IDF ? Number(dto.CCH_IDF) : undefined,
  chantierTitle: dto.CHANTIER_TITLE || '',
  chantierCode: dto.CHANTIER_CODE || '',
  clientName: dto.CLIENT_NAME || '',
  projectId: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  COP_IDF: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  contactId: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  CCT_IDF: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  contactName: dto.CONTACT_NAME || '',
  subject: dto.CRC_SUBJECT || '',
  CRC_SUBJECT: dto.CRC_SUBJECT || '',
  type: dto.CRC_TYPE || 'DEFAUT_POSE',
  CRC_TYPE: dto.CRC_TYPE || 'DEFAUT_POSE',
  severity: dto.CRC_SEVERITY || 'MEDIUM',
  CRC_SEVERITY: dto.CRC_SEVERITY || 'MEDIUM',
  status: dto.CRC_STATUS || 'OPEN',
  CRC_STATUS: dto.CRC_STATUS || 'OPEN',
  dateReported: dto.CRC_DATE_REPORTED ? new Date(dto.CRC_DATE_REPORTED).toISOString().substring(0, 16) : '',
  CRC_DATE_REPORTED: dto.CRC_DATE_REPORTED,
  dateResolved: dto.CRC_DATE_RESOLVED ? new Date(dto.CRC_DATE_RESOLVED).toISOString().substring(0, 16) : '',
  CRC_DATE_RESOLVED: dto.CRC_DATE_RESOLVED,
  resolutionNotes: dto.CRC_RESOLUTION_NOTES || '',
  CRC_RESOLUTION_NOTES: dto.CRC_RESOLUTION_NOTES || '',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const mapActivity = (dto: any): CrmActivity => ({
  id: dto.CAC_IDF,
  CAC_IDF: dto.CAC_IDF,
  CAC_UIDF: dto.CAC_UIDF,
  code: dto.CAC_CODE || '',
  CAC_CODE: dto.CAC_CODE || '',
  type: dto.CAC_TYPE || 'CALL',
  CAC_TYPE: dto.CAC_TYPE || 'CALL',
  subject: dto.CAC_SUBJECT || '',
  CAC_SUBJECT: dto.CAC_SUBJECT || '',
  date: dto.CAC_DATD ? new Date(dto.CAC_DATD).toISOString().replace('T', ' ').substring(0, 16) : '',
  CAC_DATD: dto.CAC_DATD,
  status: dto.CAC_STATUS || 'PENDING',
  CAC_STATUS: dto.CAC_STATUS || 'PENDING',
  priority: dto.CAC_PRIORITY || 'MEDIUM',
  CAC_PRIORITY: dto.CAC_PRIORITY || 'MEDIUM',
  contactId: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  CCT_IDF: dto.CCT_IDF ? Number(dto.CCT_IDF) : undefined,
  contactName: dto.CONTACT_NAME || '',
  opportunityId: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  COP_IDF: dto.COP_IDF ? Number(dto.COP_IDF) : undefined,
  opportunityTitle: dto.OPPORTUNITY_TITLE || '',
  notes: dto.CAC_NOTES || '',
  CAC_NOTES: dto.CAC_NOTES || '',
  dos_idf: dto.DOS_IDF ? Number(dto.DOS_IDF) : undefined,
  dos_code: dto.DOS_CODE,
  dos_lib: dto.DOS_LIB,
  user_lib: dto.USER_LIB,
  last_updt: dto.LAST_UPDT ? new Date(dto.LAST_UPDT).toLocaleString() : undefined,
});

export const crmApi = {
  // Leads
  async getLeads(): Promise<CrmLead[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_lead',
      Action: { OKey: 'Blobtic_CRM,crm_lead,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapLead) : [];
  },
  async insertLead(lead: Partial<CrmLead> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_lead',
      Action: {
        OKey: 'Blobtic_CRM,crm_lead,insert',
        CLD_CODE: lead.code || lead.CLD_CODE || '',
        CLD_NAME: lead.name || lead.CLD_NAME || '',
        CLD_COMPANY: lead.company || lead.CLD_COMPANY || '',
        CLD_EMAIL: lead.email || lead.CLD_EMAIL || '',
        CLD_PHONE: lead.phone || lead.CLD_PHONE || '',
        CLD_STATUS: lead.status || lead.CLD_STATUS || 'NEW',
        CLD_SOURCE: lead.source || lead.CLD_SOURCE || 'WEBSITE',
        CLD_VALUE: lead.value ?? lead.CLD_VALUE ?? 0,
        CLD_NOTES: lead.notes || lead.CLD_NOTES || ''
      }
    });
  },
  async updateLead(lead: Partial<CrmLead> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_lead',
      Action: {
        OKey: 'Blobtic_CRM,crm_lead,update',
        CLD_IDF: lead.id || lead.CLD_IDF,
        CLD_CODE: lead.code || lead.CLD_CODE,
        CLD_NAME: lead.name || lead.CLD_NAME,
        CLD_COMPANY: lead.company || lead.CLD_COMPANY,
        CLD_EMAIL: lead.email || lead.CLD_EMAIL,
        CLD_PHONE: lead.phone || lead.CLD_PHONE,
        CLD_STATUS: lead.status || lead.CLD_STATUS,
        CLD_SOURCE: lead.source || lead.CLD_SOURCE,
        CLD_VALUE: lead.value ?? lead.CLD_VALUE,
        CLD_NOTES: lead.notes || lead.CLD_NOTES
      }
    });
  },
  async deleteLead(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_lead',
      Action: {
        OKey: 'Blobtic_CRM,crm_lead,delete',
        CLD_IDF: id
      }
    });
  },

  // Contacts
  async getContacts(): Promise<CrmContact[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_contact',
      Action: { OKey: 'Blobtic_CRM,crm_contact,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapContact) : [];
  },
  async insertContact(contact: Partial<CrmContact> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_contact',
      Action: {
        OKey: 'Blobtic_CRM,crm_contact,insert',
        CCT_CODE: contact.code || contact.CCT_CODE || '',
        CCT_FIRSTNAME: contact.firstName || contact.CCT_FIRSTNAME || '',
        CCT_LASTNAME: contact.lastName || contact.CCT_LASTNAME || '',
        COR_IDF: contact.organisationId || contact.COR_IDF,
        CCT_COMPANY: contact.company || contact.CCT_COMPANY || '',
        CCT_ROLE: contact.role || contact.CCT_ROLE || '',
        CCT_EMAIL: contact.email || contact.CCT_EMAIL || '',
        CCT_PHONE: contact.phone || contact.CCT_PHONE || '',
        CCT_MOBILE: contact.mobile || contact.CCT_MOBILE || '',
        CCT_ADDRESS: contact.address || contact.CCT_ADDRESS || '',
        CCT_CITY: contact.city || contact.CCT_CITY || '',
        CCT_TYPE: contact.type || contact.CCT_TYPE || 'CLIENT',
        CCT_INFLUENCE: contact.influence ?? contact.CCT_INFLUENCE ?? 3,
        CCT_PREF_COMM: contact.prefComm || contact.CCT_PREF_COMM || 'EMAIL',
        CCT_PREF_HOURS: contact.prefHours || contact.CCT_PREF_HOURS || '',
        CCT_PREF_LANG: contact.prefLang || contact.CCT_PREF_LANG || 'FR'
      }
    });
  },
  async updateContact(contact: Partial<CrmContact> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_contact',
      Action: {
        OKey: 'Blobtic_CRM,crm_contact,update',
        CCT_IDF: contact.id || contact.CCT_IDF,
        CCT_CODE: contact.code || contact.CCT_CODE,
        CCT_FIRSTNAME: contact.firstName || contact.CCT_FIRSTNAME,
        CCT_LASTNAME: contact.lastName || contact.CCT_LASTNAME,
        COR_IDF: contact.organisationId || contact.COR_IDF,
        CCT_COMPANY: contact.company || contact.CCT_COMPANY,
        CCT_ROLE: contact.role || contact.CCT_ROLE,
        CCT_EMAIL: contact.email || contact.CCT_EMAIL,
        CCT_PHONE: contact.phone || contact.CCT_PHONE,
        CCT_MOBILE: contact.mobile || contact.CCT_MOBILE,
        CCT_ADDRESS: contact.address || contact.CCT_ADDRESS,
        CCT_CITY: contact.city || contact.CCT_CITY,
        CCT_TYPE: contact.type || contact.CCT_TYPE,
        CCT_INFLUENCE: contact.influence ?? contact.CCT_INFLUENCE,
        CCT_PREF_COMM: contact.prefComm || contact.CCT_PREF_COMM,
        CCT_PREF_HOURS: contact.prefHours || contact.CCT_PREF_HOURS,
        CCT_PREF_LANG: contact.prefLang || contact.CCT_PREF_LANG
      }
    });
  },
  async deleteContact(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_contact',
      Action: {
        OKey: 'Blobtic_CRM,crm_contact,delete',
        CCT_IDF: id
      }
    });
  },

  // Organisations
  async getOrganisations(): Promise<CrmOrganisation[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_organisation',
      Action: { OKey: 'Blobtic_CRM,crm_organisation,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapOrganisation) : [];
  },
  async insertOrganisation(org: Partial<CrmOrganisation> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_organisation',
      Action: {
        OKey: 'Blobtic_CRM,crm_organisation,insert',
        COR_CODE: org.code || org.COR_CODE || '',
        COR_NAME: org.name || org.COR_NAME || '',
        COR_TYPE: org.type || org.COR_TYPE || 'BET',
        COR_SPECIALTY: org.specialty || org.COR_SPECIALTY || 'RESIDENTIEL',
        COR_SIZE: org.size || org.COR_SIZE || 'MOYEN',
        COR_ZONE_GEO: org.zoneGeo || org.COR_ZONE_GEO || '',
        COR_ADDRESS: org.address || org.COR_ADDRESS || '',
        COR_PHONE: org.phone || org.COR_PHONE || '',
        COR_EMAIL: org.email || org.COR_EMAIL || '',
        COR_WEBSITE: org.website || org.COR_WEBSITE || '',
        COR_HISTORY: org.history || org.COR_HISTORY || ''
      }
    });
  },
  async updateOrganisation(org: Partial<CrmOrganisation> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_organisation',
      Action: {
        OKey: 'Blobtic_CRM,crm_organisation,update',
        COR_IDF: org.id || org.COR_IDF,
        COR_CODE: org.code || org.COR_CODE,
        COR_NAME: org.name || org.COR_NAME,
        COR_TYPE: org.type || org.COR_TYPE,
        COR_SPECIALTY: org.specialty || org.COR_SPECIALTY,
        COR_SIZE: org.size || org.COR_SIZE,
        COR_ZONE_GEO: org.zoneGeo || org.COR_ZONE_GEO,
        COR_ADDRESS: org.address || org.COR_ADDRESS,
        COR_PHONE: org.phone || org.COR_PHONE,
        COR_EMAIL: org.email || org.COR_EMAIL,
        COR_WEBSITE: org.website || org.COR_WEBSITE,
        COR_HISTORY: org.history !== undefined ? org.history : (org.COR_HISTORY !== undefined ? org.COR_HISTORY : '')
      }
    });
  },
  async deleteOrganisation(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_organisation',
      Action: {
        OKey: 'Blobtic_CRM,crm_organisation,delete',
        COR_IDF: id
      }
    });
  },

  // Opportunities / Projets
  async getOpportunities(): Promise<CrmOpportunity[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_opportunity',
      Action: { OKey: 'Blobtic_CRM,crm_opportunity,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapOpportunity) : [];
  },
  async insertOpportunity(opp: Partial<CrmOpportunity> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_opportunity',
      Action: {
        OKey: 'Blobtic_CRM,crm_opportunity,insert',
        COP_CODE: opp.code || opp.COP_CODE || '',
        COP_TITLE: opp.title || opp.COP_TITLE || '',
        CCT_IDF: opp.contactId || opp.CCT_IDF,
        COR_IDF: opp.organisationId || opp.COR_IDF,
        COP_REF_INTERNE: opp.refInterne || opp.COP_REF_INTERNE || '',
        COP_TYPE_PROJET: opp.typeProjet || opp.COP_TYPE_PROJET || 'PROMOTION',
        COP_SEGMENT: opp.segment || opp.COP_SEGMENT || 'PRIVE',
        COP_CHANTIER_ADDRESS: opp.chantierAddress || opp.COP_CHANTIER_ADDRESS || '',
        COP_WILAYA: opp.wilaya || opp.COP_WILAYA || '',
        COP_GAMME: opp.gamme || opp.COP_GAMME || 'URBANIA',
        COP_UNITS: opp.units ?? opp.COP_UNITS ?? 0,
        COP_UNIT_PRICE: opp.unitPrice ?? opp.COP_UNIT_PRICE ?? 0,
        COP_DISCOUNT: opp.discount ?? opp.COP_DISCOUNT ?? 0,
        COP_EXTRA_DISCOUNT: opp.extraDiscount ?? opp.COP_EXTRA_DISCOUNT ?? 0,
        COP_PROGRESS: opp.progress ?? opp.COP_PROGRESS ?? 0,
        COP_PRIORITY: opp.priority || opp.COP_PRIORITY || 'MEDIUM',
        COP_RISK: opp.risk || opp.COP_RISK || 'LOW',
        COP_STAGE: opp.stage || opp.COP_STAGE || 'PROSPECTING',
        COP_AMOUNT: opp.amount ?? opp.COP_AMOUNT ?? 0,
        COP_PROBABILITY: opp.probability ?? opp.COP_PROBABILITY ?? 20,
        COP_CLOSEDATE: opp.closeDate || opp.COP_CLOSEDATE,
        COP_TRANSFER_STATUS: opp.transferStatus || opp.COP_TRANSFER_STATUS || 'NONE',
        COP_ACTION_REQUIRED: opp.actionRequired || opp.COP_ACTION_REQUIRED || '',
        COP_NOTES: opp.notes || opp.COP_NOTES || ''
      }
    });
  },
  async updateOpportunity(opp: Partial<CrmOpportunity> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_opportunity',
      Action: {
        OKey: 'Blobtic_CRM,crm_opportunity,update',
        COP_IDF: opp.id || opp.COP_IDF,
        COP_CODE: opp.code || opp.COP_CODE,
        COP_TITLE: opp.title || opp.COP_TITLE,
        CCT_IDF: opp.contactId || opp.CCT_IDF,
        COR_IDF: opp.organisationId || opp.COR_IDF,
        COP_REF_INTERNE: opp.refInterne || opp.COP_REF_INTERNE,
        COP_TYPE_PROJET: opp.typeProjet || opp.COP_TYPE_PROJET,
        COP_SEGMENT: opp.segment || opp.COP_SEGMENT,
        COP_CHANTIER_ADDRESS: opp.chantierAddress || opp.COP_CHANTIER_ADDRESS,
        COP_WILAYA: opp.wilaya || opp.COP_WILAYA,
        COP_GAMME: opp.gamme || opp.COP_GAMME,
        COP_UNITS: opp.units ?? opp.COP_UNITS,
        COP_UNIT_PRICE: opp.unitPrice ?? opp.COP_UNIT_PRICE,
        COP_DISCOUNT: opp.discount ?? opp.COP_DISCOUNT,
        COP_EXTRA_DISCOUNT: opp.extraDiscount ?? opp.COP_EXTRA_DISCOUNT,
        COP_PROGRESS: opp.progress ?? opp.COP_PROGRESS,
        COP_PRIORITY: opp.priority || opp.COP_PRIORITY,
        COP_RISK: opp.risk || opp.COP_RISK,
        COP_STAGE: opp.stage || opp.COP_STAGE,
        COP_AMOUNT: opp.amount ?? opp.COP_AMOUNT,
        COP_PROBABILITY: opp.probability ?? opp.COP_PROBABILITY,
        COP_CLOSEDATE: opp.closeDate || opp.COP_CLOSEDATE,
        COP_TRANSFER_STATUS: opp.transferStatus || opp.COP_TRANSFER_STATUS,
        COP_ACTION_REQUIRED: opp.actionRequired || opp.COP_ACTION_REQUIRED,
        COP_NOTES: opp.notes || opp.COP_NOTES
      }
    });
  },
  async deleteOpportunity(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_opportunity',
      Action: {
        OKey: 'Blobtic_CRM,crm_opportunity,delete',
        COP_IDF: id
      }
    });
  },
  async transferOpportunityToKam(copId: number, kamName: string = 'Karim Benali') {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_transfer',
      Action: {
        OKey: 'Blobtic_CRM,crm_transfer,transfer_to_kam',
        COP_IDF: copId,
        KAM_NAME: kamName
      }
    });
  },

  // CDC (Cahiers des charges)
  async getCdcs(): Promise<CrmCdc[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_cdc',
      Action: { OKey: 'Blobtic_CRM,crm_cdc,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapCdc) : [];
  },
  async insertCdc(cdc: Partial<CrmCdc> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_cdc',
      Action: {
        OKey: 'Blobtic_CRM,crm_cdc,insert',
        CDC_CODE: cdc.code || cdc.CDC_CODE || '',
        CDC_TITLE: cdc.title || cdc.CDC_TITLE || '',
        COP_IDF: cdc.projectId || cdc.COP_IDF,
        COR_IDF: cdc.organisationId || cdc.COR_IDF,
        CCT_IDF: cdc.contactId || cdc.CCT_IDF,
        CDC_DATE_CREATION: cdc.dateCreation || cdc.CDC_DATE_CREATION,
        CDC_DATE_SIGNATURE: cdc.dateSignature || cdc.CDC_DATE_SIGNATURE,
        CDC_STATUS: cdc.status || cdc.CDC_STATUS || 'DRAFT',
        CDC_GAMME: cdc.gamme || cdc.CDC_GAMME || 'URBANIA',
        CDC_UNITS_COUNT: cdc.unitsCount ?? cdc.CDC_UNITS_COUNT ?? 0,
        CDC_ESTIMATED_BUDGET: cdc.estimatedBudget ?? cdc.CDC_ESTIMATED_BUDGET ?? 0,
        CDC_TECHNICAL_CONSTRAINTS: cdc.technicalConstraints || cdc.CDC_TECHNICAL_CONSTRAINTS || '',
        CDC_DOC_PATH: cdc.docPath || cdc.CDC_DOC_PATH || ''
      }
    });
  },
  async updateCdc(cdc: Partial<CrmCdc> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_cdc',
      Action: {
        OKey: 'Blobtic_CRM,crm_cdc,update',
        CDC_IDF: cdc.id || cdc.CDC_IDF,
        CDC_CODE: cdc.code || cdc.CDC_CODE,
        CDC_TITLE: cdc.title || cdc.CDC_TITLE,
        COP_IDF: cdc.projectId || cdc.COP_IDF,
        COR_IDF: cdc.organisationId || cdc.COR_IDF,
        CCT_IDF: cdc.contactId || cdc.CCT_IDF,
        CDC_DATE_CREATION: cdc.dateCreation || cdc.CDC_DATE_CREATION,
        CDC_DATE_SIGNATURE: cdc.dateSignature || cdc.CDC_DATE_SIGNATURE,
        CDC_STATUS: cdc.status || cdc.CDC_STATUS,
        CDC_GAMME: cdc.gamme || cdc.CDC_GAMME,
        CDC_UNITS_COUNT: cdc.unitsCount ?? cdc.CDC_UNITS_COUNT,
        CDC_ESTIMATED_BUDGET: cdc.estimatedBudget ?? cdc.CDC_ESTIMATED_BUDGET,
        CDC_TECHNICAL_CONSTRAINTS: cdc.technicalConstraints || cdc.CDC_TECHNICAL_CONSTRAINTS,
        CDC_DOC_PATH: cdc.docPath || cdc.CDC_DOC_PATH
      }
    });
  },
  async deleteCdc(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_cdc',
      Action: {
        OKey: 'Blobtic_CRM,crm_cdc,delete',
        CDC_IDF: id
      }
    });
  },

  // Visites Terrain
  async getVisits(): Promise<CrmVisit[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_visit',
      Action: { OKey: 'Blobtic_CRM,crm_visit,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapVisit) : [];
  },
  async insertVisit(visit: Partial<CrmVisit> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_visit',
      Action: {
        OKey: 'Blobtic_CRM,crm_visit,insert',
        CVS_CODE: visit.code || visit.CVS_CODE || '',
        CVS_ROLE: visit.role || visit.CVS_ROLE || 'PRESCRIPTEUR',
        CVS_TYPE: visit.type || visit.CVS_TYPE || 'PROSPECTION',
        COR_IDF: visit.organisationId || visit.COR_IDF,
        CCT_IDF: visit.contactId || visit.CCT_IDF,
        COP_IDF: visit.projectId || visit.COP_IDF,
        CVS_SCHEDULED_DATETIME: visit.scheduledDateTime || visit.CVS_SCHEDULED_DATETIME,
        CVS_OBJECTIVE: visit.objective || visit.CVS_OBJECTIVE || '',
        CVS_CHECKLIST: visit.checklist || visit.CVS_CHECKLIST || '',
        CVS_STATUS: visit.status || visit.CVS_STATUS || 'PLANNED',
        CVS_CHECKIN_TIME: visit.checkinTime || visit.CVS_CHECKIN_TIME,
        CVS_CHECKIN_LAT: visit.checkinLat ?? visit.CVS_CHECKIN_LAT,
        CVS_CHECKIN_LON: visit.checkinLon ?? visit.CVS_CHECKIN_LON,
        CVS_CHECKOUT_TIME: visit.checkoutTime || visit.CVS_CHECKOUT_TIME,
        CVS_DURATION_MINUTES: visit.durationMinutes ?? visit.CVS_DURATION_MINUTES ?? 0,
        CVS_PERSONS_MET: visit.personsMet || visit.CVS_PERSONS_MET || '',
        CVS_TOPICS: visit.topics || visit.CVS_TOPICS || '',
        CVS_COMMITMENTS: visit.commitments || visit.CVS_COMMITMENTS || '',
        CVS_NEXT_STEPS: visit.nextSteps || visit.CVS_NEXT_STEPS || '',
        CVS_EVALUATION_SCORE: visit.evaluationScore ?? visit.CVS_EVALUATION_SCORE ?? 8,
        CVS_REPORT: visit.report || visit.CVS_REPORT || ''
      }
    });
  },
  async updateVisit(visit: Partial<CrmVisit> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_visit',
      Action: {
        OKey: 'Blobtic_CRM,crm_visit,update',
        CVS_IDF: visit.id || visit.CVS_IDF,
        CVS_CODE: visit.code || visit.CVS_CODE,
        CVS_ROLE: visit.role || visit.CVS_ROLE,
        CVS_TYPE: visit.type || visit.CVS_TYPE,
        COR_IDF: visit.organisationId || visit.COR_IDF,
        CCT_IDF: visit.contactId || visit.CCT_IDF,
        COP_IDF: visit.projectId || visit.COP_IDF,
        CVS_SCHEDULED_DATETIME: visit.scheduledDateTime || visit.CVS_SCHEDULED_DATETIME,
        CVS_OBJECTIVE: visit.objective || visit.CVS_OBJECTIVE,
        CVS_CHECKLIST: visit.checklist || visit.CVS_CHECKLIST,
        CVS_STATUS: visit.status || visit.CVS_STATUS,
        CVS_CHECKIN_TIME: visit.checkinTime || visit.CVS_CHECKIN_TIME,
        CVS_CHECKIN_LAT: visit.checkinLat ?? visit.CVS_CHECKIN_LAT,
        CVS_CHECKIN_LON: visit.checkinLon ?? visit.CVS_CHECKIN_LON,
        CVS_CHECKOUT_TIME: visit.checkoutTime || visit.CVS_CHECKOUT_TIME,
        CVS_DURATION_MINUTES: visit.durationMinutes ?? visit.CVS_DURATION_MINUTES,
        CVS_PERSONS_MET: visit.personsMet || visit.CVS_PERSONS_MET,
        CVS_TOPICS: visit.topics || visit.CVS_TOPICS,
        CVS_COMMITMENTS: visit.commitments || visit.CVS_COMMITMENTS,
        CVS_NEXT_STEPS: visit.nextSteps || visit.CVS_NEXT_STEPS,
        CVS_EVALUATION_SCORE: visit.evaluationScore ?? visit.CVS_EVALUATION_SCORE,
        CVS_REPORT: visit.report || visit.CVS_REPORT
      }
    });
  },
  async deleteVisit(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_visit',
      Action: {
        OKey: 'Blobtic_CRM,crm_visit,delete',
        CVS_IDF: id
      }
    });
  },

  // Chantiers KAM
  async getChantiers(): Promise<CrmChantier[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_chantier',
      Action: { OKey: 'Blobtic_CRM,crm_chantier,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapChantier) : [];
  },
  async insertChantier(chantier: Partial<CrmChantier> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_chantier',
      Action: {
        OKey: 'Blobtic_CRM,crm_chantier,insert',
        CCH_CODE: chantier.code || chantier.CCH_CODE || '',
        CCH_TITLE: chantier.title || chantier.CCH_TITLE || '',
        COP_IDF: chantier.projectId || chantier.COP_IDF,
        COR_IDF: chantier.organisationId || chantier.COR_IDF,
        CCT_IDF: chantier.contactId || chantier.CCT_IDF,
        CCH_CLIENT_NAME: chantier.clientName || chantier.CCH_CLIENT_NAME || '',
        CCH_ADDRESS: chantier.address || chantier.CCH_ADDRESS || '',
        CCH_WILAYA: chantier.wilaya || chantier.CCH_WILAYA || '',
        CCH_STATUS: chantier.status || chantier.CCH_STATUS || 'DEMARRAGE',
        CCH_START_DATE: chantier.startDate || chantier.CCH_START_DATE,
        CCH_ESTIMATED_END_DATE: chantier.estimatedEndDate || chantier.CCH_ESTIMATED_END_DATE,
        CCH_PROGRESS: chantier.progress ?? chantier.CCH_PROGRESS ?? 0,
        CCH_KAM_NAME: chantier.kamName || chantier.CCH_KAM_NAME || '',
        CCH_ORDERS_COUNT: chantier.ordersCount ?? chantier.CCH_ORDERS_COUNT ?? 0,
        CCH_ORDERS_PENDING: chantier.ordersPending ?? chantier.CCH_ORDERS_PENDING ?? 0,
        CCH_ORDERS_LATE: chantier.ordersLate ?? chantier.CCH_ORDERS_LATE ?? 0,
        CCH_DELIVERY_STATUS: chantier.deliveryStatus || chantier.CCH_DELIVERY_STATUS || 'ON_SCHEDULE',
        CCH_TOTAL_CA: chantier.totalCa ?? chantier.CCH_TOTAL_CA ?? 0,
        CCH_MARGIN_PCT: chantier.marginPct ?? chantier.CCH_MARGIN_PCT ?? 0,
        CCH_COLLECTED_PCT: chantier.collectedPct ?? chantier.CCH_COLLECTED_PCT ?? 0,
        CCH_SATISFACTION_SCORE: chantier.satisfactionScore ?? chantier.CCH_SATISFACTION_SCORE ?? 85
      }
    });
  },
  async updateChantier(chantier: Partial<CrmChantier> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_chantier',
      Action: {
        OKey: 'Blobtic_CRM,crm_chantier,update',
        CCH_IDF: chantier.id || chantier.CCH_IDF,
        CCH_CODE: chantier.code || chantier.CCH_CODE,
        CCH_TITLE: chantier.title || chantier.CCH_TITLE,
        COP_IDF: chantier.projectId || chantier.COP_IDF,
        COR_IDF: chantier.organisationId || chantier.COR_IDF,
        CCT_IDF: chantier.contactId || chantier.CCT_IDF,
        CCH_CLIENT_NAME: chantier.clientName || chantier.CCH_CLIENT_NAME,
        CCH_ADDRESS: chantier.address || chantier.CCH_ADDRESS,
        CCH_WILAYA: chantier.wilaya || chantier.CCH_WILAYA,
        CCH_STATUS: chantier.status || chantier.CCH_STATUS,
        CCH_START_DATE: chantier.startDate || chantier.CCH_START_DATE,
        CCH_ESTIMATED_END_DATE: chantier.estimatedEndDate || chantier.CCH_ESTIMATED_END_DATE,
        CCH_ACTUAL_END_DATE: chantier.actualEndDate || chantier.CCH_ACTUAL_END_DATE,
        CCH_PROGRESS: chantier.progress ?? chantier.CCH_PROGRESS,
        CCH_KAM_NAME: chantier.kamName || chantier.CCH_KAM_NAME,
        CCH_ORDERS_COUNT: chantier.ordersCount ?? chantier.CCH_ORDERS_COUNT,
        CCH_ORDERS_PENDING: chantier.ordersPending ?? chantier.CCH_ORDERS_PENDING,
        CCH_ORDERS_LATE: chantier.ordersLate ?? chantier.CCH_ORDERS_LATE,
        CCH_DELIVERY_STATUS: chantier.deliveryStatus || chantier.CCH_DELIVERY_STATUS,
        CCH_TOTAL_CA: chantier.totalCa ?? chantier.CCH_TOTAL_CA,
        CCH_MARGIN_PCT: chantier.marginPct ?? chantier.CCH_MARGIN_PCT,
        CCH_COLLECTED_PCT: chantier.collectedPct ?? chantier.CCH_COLLECTED_PCT,
        CCH_SATISFACTION_SCORE: chantier.satisfactionScore ?? chantier.CCH_SATISFACTION_SCORE
      }
    });
  },
  async deleteChantier(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_chantier',
      Action: {
        OKey: 'Blobtic_CRM,crm_chantier,delete',
        CCH_IDF: id
      }
    });
  },

  // Réclamations SAV
  async getReclamations(): Promise<CrmReclamation[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_reclamation',
      Action: { OKey: 'Blobtic_CRM,crm_reclamation,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapReclamation) : [];
  },
  async insertReclamation(rec: Partial<CrmReclamation> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_reclamation',
      Action: {
        OKey: 'Blobtic_CRM,crm_reclamation,insert',
        CRC_CODE: rec.code || rec.CRC_CODE || '',
        CCH_IDF: rec.chantierId || rec.CCH_IDF,
        COP_IDF: rec.projectId || rec.COP_IDF,
        CCT_IDF: rec.contactId || rec.CCT_IDF,
        CRC_SUBJECT: rec.subject || rec.CRC_SUBJECT || '',
        CRC_TYPE: rec.type || rec.CRC_TYPE || 'DEFAUT_POSE',
        CRC_SEVERITY: rec.severity || rec.CRC_SEVERITY || 'MEDIUM',
        CRC_STATUS: rec.status || rec.CRC_STATUS || 'OPEN',
        CRC_DATE_REPORTED: rec.dateReported || rec.CRC_DATE_REPORTED,
        CRC_RESOLUTION_NOTES: rec.resolutionNotes || rec.CRC_RESOLUTION_NOTES || ''
      }
    });
  },
  async updateReclamation(rec: Partial<CrmReclamation> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_reclamation',
      Action: {
        OKey: 'Blobtic_CRM,crm_reclamation,update',
        CRC_IDF: rec.id || rec.CRC_IDF,
        CRC_CODE: rec.code || rec.CRC_CODE,
        CCH_IDF: rec.chantierId || rec.CCH_IDF,
        COP_IDF: rec.projectId || rec.COP_IDF,
        CCT_IDF: rec.contactId || rec.CCT_IDF,
        CRC_SUBJECT: rec.subject || rec.CRC_SUBJECT,
        CRC_TYPE: rec.type || rec.CRC_TYPE,
        CRC_SEVERITY: rec.severity || rec.CRC_SEVERITY,
        CRC_STATUS: rec.status || rec.CRC_STATUS,
        CRC_DATE_REPORTED: rec.dateReported || rec.CRC_DATE_REPORTED,
        CRC_DATE_RESOLVED: rec.dateResolved || rec.CRC_DATE_RESOLVED,
        CRC_RESOLUTION_NOTES: rec.resolutionNotes || rec.CRC_RESOLUTION_NOTES
      }
    });
  },
  async deleteReclamation(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_reclamation',
      Action: {
        OKey: 'Blobtic_CRM,crm_reclamation,delete',
        CRC_IDF: id
      }
    });
  },

  // Activities
  async getActivities(): Promise<CrmActivity[]> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_activity',
      Action: { OKey: 'Blobtic_CRM,crm_activity,select' }
    });
    return (res.success && Array.isArray(res.data)) ? res.data.map(mapActivity) : [];
  },
  async insertActivity(act: Partial<CrmActivity> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_activity',
      Action: {
        OKey: 'Blobtic_CRM,crm_activity,insert',
        CAC_CODE: act.code || act.CAC_CODE || '',
        CAC_TYPE: act.type || act.CAC_TYPE || 'CALL',
        CAC_SUBJECT: act.subject || act.CAC_SUBJECT || '',
        CAC_DATD: act.date || act.CAC_DATD,
        CAC_STATUS: act.status || act.CAC_STATUS || 'PENDING',
        CAC_PRIORITY: act.priority || act.CAC_PRIORITY || 'MEDIUM',
        CCT_IDF: act.contactId || act.CCT_IDF,
        COP_IDF: act.opportunityId || act.COP_IDF,
        CAC_NOTES: act.notes || act.CAC_NOTES || ''
      }
    });
  },
  async updateActivity(act: Partial<CrmActivity> | any) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_activity',
      Action: {
        OKey: 'Blobtic_CRM,crm_activity,update',
        CAC_IDF: act.id || act.CAC_IDF,
        CAC_CODE: act.code || act.CAC_CODE,
        CAC_TYPE: act.type || act.CAC_TYPE,
        CAC_SUBJECT: act.subject || act.CAC_SUBJECT,
        CAC_DATD: act.date || act.CAC_DATD,
        CAC_STATUS: act.status || act.CAC_STATUS,
        CAC_PRIORITY: act.priority || act.CAC_PRIORITY,
        CCT_IDF: act.contactId || act.CCT_IDF,
        COP_IDF: act.opportunityId || act.COP_IDF,
        CAC_NOTES: act.notes || act.CAC_NOTES
      }
    });
  },
  async deleteActivity(id: number) {
    return await blobticService.executeZoomRequest({
      ZoomKey: 'crm_activity',
      Action: {
        OKey: 'Blobtic_CRM,crm_activity,delete',
        CAC_IDF: id
      }
    });
  },

  // Dashboard Stats
  async getDashboardStats(): Promise<CrmDashboardStats> {
    const res = await blobticService.executeZoomRequest<any>({
      ZoomKey: 'crm_dashboard',
      Action: { OKey: 'Blobtic_CRM,crm_dashboard,select' }
    });
    if (res.success && res.data) {
      return res.data as CrmDashboardStats;
    }
    return {
      totalLeads: 0,
      newLeads: 0,
      totalContacts: 0,
      totalOpportunities: 0,
      pipelineAmount: 0,
      wonAmount: 0,
      pendingActivities: 0
    };
  }
};
